import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import EditFormTemplateQuestionBox from './EditFormTemplateQuestionBox';
import { FormItem } from '../../types';

interface SortableQuestionBoxProps {
  question: FormItem;
  pageNumber?: number;
  isPageBreak?: boolean;
  missingLanguages?: string[];
  softMissingLanguages?: string[];
  renderInputForType: (question: FormItem) => React.ReactNode;
  onEdit: (question: FormItem) => void;
  onDelete: (question: FormItem) => void;
  onDuplicate: (question: FormItem) => void;
}

const SortableQuestionBox: React.FC<SortableQuestionBoxProps> = ({
  question,
  pageNumber,
  isPageBreak,
  missingLanguages,
  softMissingLanguages,
  renderInputForType,
  onEdit,
  onDelete,
  onDuplicate,
}) => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id: question.guid,
  });

  return (
    <div
      ref={setNodeRef}
      style={{
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: isDragging ? 0.6 : 1,
        zIndex: isDragging ? 2 : 1,
      }}
    >
      <EditFormTemplateQuestionBox
        question={question}
        pageNumber={pageNumber}
        isPageBreak={isPageBreak}
        missingLanguages={missingLanguages}
        softMissingLanguages={softMissingLanguages}
        onEdit={onEdit}
        onDelete={onDelete}
        onDuplicate={onDuplicate}
        renderInputForType={renderInputForType}
        dragHandleProps={{ ...attributes, ...listeners }}
      />
    </div>
  );
};

export default SortableQuestionBox;
